module.exports = __webpack_public_path__ + "img/icn-history-cd.1dfb2fe2.png";